type RouteId = number | string | undefined;

export class pageRouteUrls
{
    public static Home(): string  {
        return  `/Home`;
    }
    public static Search(): string  {
        return  `/Search`;
    }
    public static Request_Add(): string {
        return  `/FormalRequest/Add`;
    }
    public static Request_Edit(id:RouteId): string {
        if(!id || id==0)
            return this.Request_Add();
        else
            return `/FormalRequest/Edit/${id}`;
    }
    public static Request_Details(id:RouteId): string {
        return `/FormalRequest/Details/${id}`;
    } 
  
    public static Action_Add(requestId:RouteId): string {
        return  `/FormalRequest/${requestId}/Action/Add`;
    }
    public static Action_Edit(requestId:RouteId,id:RouteId): string {
        if(!id || id==0)
            return this.Action_Add(requestId);
        else
            return `/FormalRequest/${requestId}/Action/Edit/${id}`;
    }
    public static Action_Details(requestId:RouteId,id:RouteId): string {
        return `/FormalRequest/${requestId}/Action/Details/${id}`;
    }          
    public static Applicant_Add(): string {
        return  `/Applicant/Add`; 
    }
    public static Applicant_Edit(id:RouteId): string {
        if(!id || id==0)
            return this.Applicant_Add();
        else
            return `/Applicant/Edit/${id}`; 
            
    }
    public static Applicant_Details(id:RouteId): string {
         return `/Applicant/Details/${id}`; 
    }     

    public static MngExceptions(requestId:RouteId): string {
        return  `/FormalRequest/${requestId}/MngExceptions`;
    }

    public static Reports(): string {
        return `/Reports/Reports`; 
    }    

    public static NotificationsConfig_View(): string {
        return  `/Notifications/Config`; 
    }  
    public static NotificationsConfig_Edit(): string {
        return  `/Notifications/Edit`; 
    }
    public static ConfigureExceptions_View():string{
        return  `/ConfigureExceptions/View`;         
    }
    public static ConfigureExceptions_Add():string{
        return  `/ConfigureExceptions/Add`;         
    }
    public static Holidays(): string {
        return `/Holidays`;
    }
    public static ManageRequests(): string {
        return `/ManageRequests`;
    }
}
